import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'
import { CreateExtraPayload, ExtraView, UpdateExtraPayload } from './model'
import { SearchExtraParams } from './model'
import { Pagination } from '@tokeet-frontend/tv3-platform'

export const LoadExtras = createAction(
  '[Extra] Load Extras',
  props<{ params?: SearchExtraParams; pagination?: Pagination }>()
)
export const LoadExtrasComplete = createAction('[Extra] Load Extras Complete', props<{ extras: ExtraView[] }>())

export const LoadExtrasByIds = createAction('[Extra] Load Extras By Ids', props<{ ids: string[] }>())
export const LoadExtrasByIdsComplete = createAction(
  '[Extra] Load Extras By Ids Complete',
  props<{ extras: ExtraView[] }>()
)

export const AddExtra = createAction('[Extra] Add Extra', props<{ payload: CreateExtraPayload }>())
export const AddExtraComplete = createAction('[Extra] Add Extra Complete', props<{ extra: ExtraView }>())

export const UpdateExtra = createAction(
  '[Extra] Update Extra',
  props<{ payload: UpdateExtraPayload; extraId: string }>()
)
export const UpdateExtraComplete = createAction('[Extra] Update Extra Complete', props<{ update: Update<ExtraView> }>())

export const DeleteExtra = createAction('[Extra] Delete Extra', props<{ id: string }>())
export const DeleteExtraComplete = createAction('[Extra] Delete Extra Complete', props<{ id: string }>())

export const DeleteExtras = createAction('[Extra] Delete Extras', props<{ ids: string[] }>())
export const DeleteExtrasComplete = createAction('[Extra] Delete Extras Complete', props<{ ids: string[] }>())
